package br.com.vvrefeicoes.portal.feature.purchases

import br.com.vvrefeicoes.portal.domain.model.PurchasesProductRow

internal fun filterPurchasesProducts(
    rows: List<PurchasesProductRow>,
    query: String,
): List<PurchasesProductRow> {
    val term = query.trim()
    if (term.isEmpty()) return rows
    return rows.filter { it.name.contains(term, ignoreCase = true) }
}
